import React, { Component } from "react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Table } from "semantic-ui-react";
import { withTranslation } from "react-i18next";
import SubscriptionItemTableRow from "~/modules/BillingCentral/components/SubscriptionItemTableRow";
import CommonHelper from "~/utils/CommonHelper";
import OtherProduct from "~/models/OtherProduct";

@observer
class SubscriptionTable extends Component {
  render() {
    const {
      t,
      subscriptionItems,
      otherProducts,
      applicableTaxes,
      subtotal,
      totalAmountWithTaxes,
      calculatePriceForDaysCallback,
      daysTillNextBillingCycle,
    } = this.props;

    const orderedByOtherProductIdSubscriptionItems = []
      .concat(subscriptionItems)
      .sort((a, b) => (a.otherProductId > b.otherProductId ? 1 : -1));

    return (
      <Table basic="very">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>{t("billingCentral:package")}</Table.HeaderCell>
            <Table.HeaderCell>{t("quantity")}</Table.HeaderCell>
            <Table.HeaderCell>{t("price")}</Table.HeaderCell>
            <Table.HeaderCell textAlign="left">{t("total")}</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {orderedByOtherProductIdSubscriptionItems.map((subscriptionItem, index) => (
            <SubscriptionItemTableRow
              /* eslint-disable-next-line react/no-array-index-key */
              key={index}
              subscriptionItem={subscriptionItem}
              otherProduct={otherProducts.find(
                otherProduct => otherProduct.otherProductId === subscriptionItem.otherProductId,
              )}
              daysTillNextBillingCycle={daysTillNextBillingCycle}
              calculatePriceForDaysCallback={calculatePriceForDaysCallback}
            />
          ))}
          {applicableTaxes.length > 0 && (
            <Table.Row>
              <Table.Cell />
              <Table.Cell />
              <Table.Cell textAlign="right">
                <strong>{t("subtotal")}</strong>
              </Table.Cell>
              <Table.Cell>{CommonHelper.currencyFormat(subtotal)}</Table.Cell>
            </Table.Row>
          )}
          {applicableTaxes.map(applicableTax => (
            <Table.Row key={applicableTax.taxId}>
              <Table.Cell />
              <Table.Cell />
              <Table.Cell textAlign="right">
                <strong>{applicableTax.name}</strong>
              </Table.Cell>
              <Table.Cell>{CommonHelper.currencyFormat(Math.round(subtotal * applicableTax.rate) / 100)}</Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>

        <Table.Footer>
          <Table.Row>
            <Table.HeaderCell />
            <Table.HeaderCell />
            <Table.HeaderCell textAlign="right">
              <strong>{t("total")}:</strong>
            </Table.HeaderCell>
            <Table.HeaderCell>{CommonHelper.currencyFormat(totalAmountWithTaxes)}</Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      </Table>
    );
  }
}

SubscriptionTable.propTypes = {
  t: PropTypes.func.isRequired,
  subscriptionItems: PropTypes.array.isRequired,
  otherProducts: PropTypes.arrayOf(PropTypes.instanceOf(OtherProduct)),
  applicableTaxes: PropTypes.array.isRequired,
  subtotal: PropTypes.number.isRequired,
  totalAmountWithTaxes: PropTypes.number.isRequired,
  calculatePriceForDaysCallback: PropTypes.func.isRequired,
  daysTillNextBillingCycle: PropTypes.number,
};

SubscriptionTable.defaultProps = {
  daysTillNextBillingCycle: 0,
};

export default withTranslation()(SubscriptionTable);
